/* eslint-disable react/prop-types */
import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import RoleService from "../../service/role-service.js";

const roleService = new RoleService();

await loadDictionary('role-create-role-window');

function CreateRoleWindow({isOpenWindow, onCloseWindow}) {
  const [name, setName] = useState('');

  const handleClose = () => {
    setName('');
    onCloseWindow();
  };
  
  const handleSubmit = () => {
    const role = {
      name: name,
    };

    roleService.create(role).then(result => {
      if(result) {
        handleClose();
      }
    }).catch(error => {
      console.error(error);
    });
  };

  return (
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("role-create-role-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form method="POST" id="CreateForm" onSubmit={e => {e.preventDefault(); handleSubmit()}}>
          <div className="row">
            <Form.Group className="mb-3 col" controlId="">
              <Form.Label>{i18n.t("role-create-role-window.name")}</Form.Label>
              <Form.Control type="text" value={name} onChange={e => {setName(e.target.value)}}></Form.Control>
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("role-create-role-window.cancel_button")}</Button>
        <Button variant="primary" type="submit" form="CreateForm" >{i18n.t("role-create-role-window.create_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateRoleWindow;